import { useState, useEffect } from "react";

import DashboardLayout from "../../../layouts/DashboardLayout";
import api from "../../../api";
import { useNavigate, Link, useLocation } from "react-router-dom";

export default function AppointmentEdit() {
  const location = useLocation();
  const [history, setHistory] = useState("");
  const patientFromAppointment = location.state?.patient_id || null;

  const [searchType, setSearchType] = useState("phone"); // phone | name
  const [searchQuery, setSearchQuery] = useState("");
  const [patients, setPatients] = useState([]); // search results
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [doctors, setdoctors] = useState([]);


  const [appointmentData, setAppointmentData] = useState({
    date: "",
    time: "",
    doctor: "",
    appointmentType: ""
  });
  const navigate = useNavigate();
  const appointmentTypes = ["Clinic", "Online"];

  useEffect(() => {
    const patient_data = location.state;
    if (patient_data) {
      setSelectedPatient(patient_data);
      setAppointmentData({
        date: patient_data.date,
        time: patient_data.time,
        doctor: patient_data.doctor_id,
        appointmentType: patient_data.appttype
      })
      console.log(location.state);
    }
    loaddoctors();
  }, []);

  const loaddoctors = async () => {
    try {
      const res = await api.fetchDoctors();
      setdoctors(res.data?.data || res.data || []);
      //select doctor

    } catch (err) {
      setError("Failed to load doctors:", err);
    } finally {
      setLoading(false);
    }
  };


  const handleAppointmentChange = (e) => {
    const { name, value } = e.target;
    setAppointmentData({
      ...appointmentData,
      [name]: value,
    });
  };

  // ✅ Update appointment via API
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedPatient) {
      alert("Please select a patient first!");
      return;
    }

    if (selectedPatient.has_consultation) {
      alert("This appointment cannot be edited because a consultation already exists for it.");
      return;
    }

    try {
      const payload = {
        patient_id: selectedPatient.patient_id,
        date: appointmentData.date,
        time: appointmentData.time,
        doctor: appointmentData.doctor,
        appointmentType: appointmentData.appointmentType,
      };

      const res = await api.updateAppointment(selectedPatient.id, payload);
      if (res.status !== 200) throw new Error(res.data?.error || "Failed to update appointment");

      alert("Appointment updated successfully!");
      navigate("/appointment");
    } catch (err) {
      console.error("Appointment updation failed:", err);
      const errMsg = err.response?.data?.error || err.message;
      alert(errMsg);
    }
  };


  return (
    <DashboardLayout>
      {/* Back Button */}
      <div className="mb-4">
        <Link
          to="/appointment"
          className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <span className="font-medium">Back to Appointments</span>
        </Link>
      </div>

      <div className="max-w-3xl mx-auto bg-white rounded-2xl border border-secondary-100 shadow-sm overflow-hidden">
        <div className="px-6 py-5 border-b border-secondary-100 flex items-center gap-3">
          <div className="w-9 h-9 bg-primary-100 rounded-xl flex items-center justify-center">
            <svg className="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
          </div>
          <div>
            <h2 className="text-lg font-bold text-secondary-900">Edit Appointment</h2>
            <p className="text-xs text-secondary-400">Reschedule or update this appointment's details</p>
          </div>
        </div>
        <div className="p-6">
        {/* Consultation Locked Banner */}
        {selectedPatient?.has_consultation && (
          <div className="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-lg text-amber-800 text-sm flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <span>
              This appointment already has an associated consultation and cannot be edited.
            </span>
            {selectedPatient.consultation_id && (
              <button
                type="button"
                onClick={() => navigate(`/consultation/${selectedPatient.consultation_id}`)}
                className="px-3 py-1.5 bg-blue-600 text-white rounded-md text-xs font-semibold hover:bg-blue-700 transition-colors shrink-0"
              >
                View Consultation
              </button>
            )}
          </div>
        )}

        {/* Appointment Form */}
        {selectedPatient && (
          <div>
            <div className="grid grid-cols-2 gap-4">
              <p className=" p-2 rounded w-full">Patient Name <b>{selectedPatient.patient_name} </b></p>
              <p className=" p-2 rounded w-full">Contact Number <b>{selectedPatient.patient_phone} </b></p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="date"
                  name="date"
                  value={appointmentData.date}
                  onChange={handleAppointmentChange}
                  disabled={selectedPatient.has_consultation}
                  className="border p-2 rounded w-full disabled:bg-gray-100 disabled:cursor-not-allowed"
                  required
                />
                <input
                  type="time"
                  name="time"
                  value={appointmentData.time}
                  onChange={handleAppointmentChange}
                  disabled={selectedPatient.has_consultation}
                  className="border p-2 rounded w-full disabled:bg-gray-100 disabled:cursor-not-allowed"
                  required
                />
                <select
                  name="doctor"
                  value={appointmentData.doctor}
                  onChange={handleAppointmentChange}
                  disabled={selectedPatient.has_consultation}
                  className="border p-2 rounded w-full disabled:bg-gray-100 disabled:cursor-not-allowed"
                  required
                >
                  <option value="">Select Doctor</option>
                  {doctors.map((doc) => (
                    <option key={doc.doctor_id} value={doc.doctor_id}>
                      {doc.name} ({doc.phone_number})
                    </option>
                  ))}
                </select>
                <select
                  name="appointmentType"
                  value={appointmentData.appointmentType}
                  onChange={handleAppointmentChange}
                  disabled={selectedPatient.has_consultation}
                  className="border p-2 rounded w-full disabled:bg-gray-100 disabled:cursor-not-allowed"
                  required
                >
                  <option value="">Select Appointment Type</option>
                  {appointmentTypes.map((appt, i) => (
                    <option key={i} value={appt}>{appt}</option>
                  ))}
                </select>
              </div>

              <button
                type="submit"
                disabled={selectedPatient.has_consultation}
                className={`px-4 py-2 rounded-lg font-medium text-white transition-colors ${
                  selectedPatient.has_consultation
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {selectedPatient.has_consultation ? "Appointment Locked" : "Update Appointment"}
              </button>
            </form>
          </div>
        )}
        </div>
      </div>
    </DashboardLayout>
  );
}
